import React, { useState } from 'react'

import { useHistory } from 'react-router-dom'

import {
  PlusCircle as PlusCircleIcon,
  HelpCircle as HelpCircleIcon,
  Link as LinkIcon,
} from 'react-feather'
import { Button, Tooltip } from '@material-ui/core'

import {
  Container,
  ContentHeader,
  DriveTour,
  FilterButton,
  Filters,
  LoadingFeedback,
  Page,
  Permitted,
} from 'components'
import { ExternalLinkDialog } from 'components'
import { PrivacyByDesignTable } from './components'

import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'
import usePermissions from 'hooks/usePermissions'

import constants from 'constants/index'
import { routes } from 'Routes'
import * as service from 'service'
import helpers from 'helpers'

const PrivacyByDesignMain = () => {
  const [openTour, setOpenTour] = useState(false)
  const [openExternalLink, setOpenExternalLink] = useState(false)

  const history = useHistory()
  const filter = useFilter()
  const { permitted } = usePermissions()

  const { response: responseDepartments, isLoading: isDepartmentsLoading } =
    useFetch(
      service.dponet.privacyByDesign.getDepartments,
      { order: 'name ASC' },
      [filter.drawerOpen],
    )

  const departments = responseDepartments?.data?.departments || []

  const { response: responseQuizTemplates, isLoading: isQuizTemplatesLoading } =
    useFetch(service.dponet.quizTemplates.list, { privacyByDesign: true }, [
      filter.drawerOpen,
    ])

  const quizTemplates = responseQuizTemplates?.data?.quizTemplates || []

  const {
    ONLY_LIST_PRIVACY_BY_DESIGN_DRIVER_STEPS_OBJECT,
    PRIVACY_BY_DESIGN_DRIVER_STEPS_OBJECT,
    PRIVACY_BY_DESIGN_DRIVER_STEP_0,
    PRIVACY_BY_DESIGN_DRIVER_STEP_1,
    PRIVACY_BY_DESIGN_DRIVER_STEP_LINK,
  } = constants.privacyByDesign

  const redirectToCreate = () => history.push(routes.privacyByDesign.new)

  const handleOpenTour = () => {
    const where = 'Privacy By Design'
    const title = 'Tour'

    const params = {
      action: 'tour-privacy-by-design',
    }

    helpers.mixpanel.track(where, title, params)
    setOpenTour(true)
  }

  return (
    <Page title="Privacy By Design">
      <LoadingFeedback open={isDepartmentsLoading || isQuizTemplatesLoading} />
      <Container maxWidth={false}>
        <ContentHeader title="Privacy By Design">
          <Tooltip title="Iniciar o tour guiado">
            <Button
              id={PRIVACY_BY_DESIGN_DRIVER_STEP_0}
              variant="contained"
              color="primary"
              startIcon={<HelpCircleIcon size={20} />}
              onClick={handleOpenTour}
              fullWidth
            >
              Tutorial
            </Button>
          </Tooltip>

          <Permitted
            tag={constants.permissions.PRIVACY_BY_DESIGN.MANAGE_GUEST_PORTAL}
          >
            <Button
              id={PRIVACY_BY_DESIGN_DRIVER_STEP_LINK}
              variant="contained"
              color="primary"
              startIcon={<LinkIcon size={20} />}
              onClick={() => setOpenExternalLink(true)}
              fullWidth
            >
              Link Externo
            </Button>
          </Permitted>
          <Permitted tag={constants.permissions.PRIVACY_BY_DESIGN.MANAGE}>
            <Button
              id={PRIVACY_BY_DESIGN_DRIVER_STEP_1}
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={redirectToCreate}
              fullWidth
            >
              Criar Projeto
            </Button>
          </Permitted>
          <FilterButton setDrawerOpen={filter.setDrawerOpen} fullWidth />
        </ContentHeader>
        <PrivacyByDesignTable params={filter.filters} />
      </Container>

      <Filters filter={filter}>
        <input textfieldinput="true" label="Identificador" name="id" />
        <input textfieldinput="true" label="Nome do Projeto" name="name" />
        <input
          datepickerinput="true"
          label="Última alteração"
          name="updatedAt"
        />
        <select
          autocompleteselectinput="true"
          label="Departamento"
          name="departmentId"
          optionvalues={departments}
        />
        <select
          autocompleteselectinput="true"
          label="Template do Questionário"
          name="quizTemplateId"
          optionvalues={quizTemplates}
          optionName="kind"
        />
      </Filters>

      <ExternalLinkDialog
        open={openExternalLink}
        setOpen={setOpenExternalLink}
        module="privacy_by_design"
        managePermission={
          constants.permissions.PRIVACY_BY_DESIGN.MANAGE_GUEST_PORTAL
        }
      />

      <DriveTour
        stepsMatrix={
          permitted(constants.permissions.PRIVACY_BY_DESIGN.MANAGE)
            ? PRIVACY_BY_DESIGN_DRIVER_STEPS_OBJECT
            : ONLY_LIST_PRIVACY_BY_DESIGN_DRIVER_STEPS_OBJECT
        }
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default PrivacyByDesignMain
